export const PILL_INFO = {
  6: {
    type: "dyk",
    textKey: "Quiz_PillInfo_6_Text",
  },
  7: {
    type: "why",
    textKey: "Quiz_PillInfo_7_Text",
  },
  8: {
    type: "why",
    textKey: "Quiz_PillInfo_8_Text",
  },
  13: {
    type: "why",
    textKey: "Quiz_PillInfo_13_Text",
  },
  16: {
    type: "dyk",
    textKey: "Quiz_PillInfo_16_Text",
  },
  18: {
    type: "why",
    textKey: "Quiz_PillInfo_18_Text",
  },
  23: {
    type: "dyk",
    textKey: "Quiz_PillInfo_23_Text",
  },
  25: {
    type: "dyk",
    textKey: "Quiz_PillInfo_25_Text",
  },
  31: {
    type: "dyk",
    textKey: "Quiz_PillInfo_31_Text",
  },
  36: {
    type: "why",
    textKey: "Quiz_PillInfo_36_Text",
  },
  38: {
    type: "why",
    textKey: "Quiz_PillInfo_38_Text",
  },
  39: {
    type: "why",
    textKey: "Quiz_PillInfo_39_Text",
  },
  40: {
    type: "why",
    textKey: "Quiz_PillInfo_40_Text",
  },
  41: {
    type: "why",
    textKey: "Quiz_PillInfo_41_Text",
  },
  42: {
    type: "why",
    textKey: "Quiz_PillInfo_42_Text",
  },
  44: {
    type: "dyk",
    textKey: "Quiz_PillInfo_44_Text",
  },
  45: {
    type: "dyk",
    textKey: "Quiz_PillInfo_45_Text",
  },
  47: {
    type: "dyk",
    textKey: "Quiz_PillInfo_47_Text",
  },
  48: {
    type: "dyk",
    textKey: "Quiz_PillInfo_48_Text",
  },
  49: {
    type: "why",
    textKey: "Quiz_PillInfo_49_Text",
  },
  50: {
    type: "dyk",
    textKey: "Quiz_PillInfo_50_Text",
  },
  51: {
    type: "dyk",
    textKey: "Quiz_PillInfo_51_Text",
  },
};
